export default function SupportHero() {
  return (
    <div className="relative h-[380px] w-full overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/c445ec90a1bf8a5aa761b83ccac1c9cf.jpg"
        alt="JobOS Support Center"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="max-w-4xl mx-auto px-6 text-center w-full">
          <div className="inline-block px-4 py-1.5 bg-[#6366F1]/20 backdrop-blur-sm border border-[#6366F1]/30 rounded-full mb-5">
            <span className="text-[#818CF8] text-sm font-medium">Help &amp; Support</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-black text-white mb-4 leading-tight tracking-tighter">
            How can we help you?
          </h1>
          <p className="text-lg text-gray-200 max-w-xl mx-auto font-medium leading-relaxed">
            Find answers, troubleshoot issues, or reach our team directly. We&apos;re here to make your job search smoother.
          </p>
        </div>
      </div>
    </div>
  );
}
